import React, { useState, useRef } from 'react';
import Modal from "components/common/modal";
import Toggle from 'components/common/Toggle'
const ScrollOption = (props) => {
    const { lockScroll, setLivefeedOptionsHandle, setLivefeedGlobalOptionsHandle } = props
    //---------------------- component's ref & state
    const lockScrollModalRef = useRef(null);
    const [globalLockScroll, setGlobalLockScroll] = useState(true);
    return (
        <div className="scroll-grid-item" >
            <div className="editor-container">
                <div className="header grid-item">FLOORPLAN SCROLL</div>
                <div className="editor-text grid-item">
                    <div>
                        <div className="scroll-toggle"
                            onClick={(e) => {
                                e.stopPropagation();
                                /* if globalLockScroll is enabled, then when the duration is modified, set globalLockScroll to be false*/
                                globalLockScroll === false && setGlobalLockScroll(true)
                                // enable scrolling means lockScroll is set to be false
                                setLivefeedOptionsHandle(!lockScroll)
                            }}>
                            <div className="toggle-text" >Enable scrolling</div>
                            <span onClick={(e) => { e.stopPropagation(); lockScrollModalRef.current.open() }}
                                className="scroll-help font-icon icon-infoIcon"></span>
                            <Toggle isActive={!lockScroll} />
                        </div>
                        <Modal
                            ref={lockScrollModalRef}
                            clickButton={() => lockScrollModalRef.current.close()}
                            header="Floorplan scroll"
                            buttonText="Got it"
                            buttonClass="btn-success"
                            entry={null}
                        >
                            <p style={{ textAlign: "left" }}>When enabled, floorplans will be zoomed in and scrolled up/down to show all sensors at a visible scale.
                                <br />Disable scrolling for smaller floorplans that do not require zooming will make the floorplans scale to fit the display area fully.
                                <br />You can have different scrolling settings for different slides
                                    </p>
                        </Modal>
                    </div>
                </div>
                <div className="editor-text grid-item global-toggle-item">
                    <div
                        data-for="floorplanOptionsTooltip"
                        style={{ whiteSpace: "normal" }}
                        data-tip="Apply&nbsp;this&nbsp;scroll&nbsp;settings&nbsp;to&nbsp;all&nbsp;slides"
                        className="global-scroll-toggle"
                        onClick={() => {
                            setGlobalLockScroll(!globalLockScroll);
                            setLivefeedGlobalOptionsHandle(lockScroll)
                        }}>
                        <div style={{ marginRight: 4 }} className="toggle-text">Apply to all slides</div>
                        <Toggle isActive={!globalLockScroll} />
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ScrollOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/ScrollOption/index.jsx